import React from 'react';

/**
 * Chapter rule: the chapter title. The heavy 2px bottom rule is what separates chapters from the
 * section headings inside them.
 */
const ChapterHeader = ({ title, subtitle }) => (
  <>
    <div className='border-b-2 border-gray-900 pb-[18px]'>
      <h2 className='m-0 font-fig-extrabold text-[38px] font-bold leading-[1.1] tracking-[-0.02em] text-gray-900'>
        {title}
      </h2>
    </div>
    {subtitle ? <p className='m-0 mt-[14px] text-ts-md text-gray-600'>{subtitle}</p> : null}
  </>
);

export default ChapterHeader;
